/* Progressive enhancement of server-rendered article links, without data mutations. */
(() => {
  document.querySelectorAll('[data-blog-index]').forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-blog-card]'));
    const topics = root.querySelector('[data-blog-topics]');
    const pagination = root.querySelector('[data-blog-pagination]');
    const status = root.querySelector('[data-blog-status]');
    if (!topics || !pagination || !status) return;
    // Keep old bookmarked pagination URLs usable for the current (<50) catalogue.
    const url = new URL(window.location.href);
    if (Number(root.dataset.articleCount) <= 50 && Number(url.searchParams.get('page')) > 1) {
      url.hash = `all/${url.searchParams.get('page')}`;
      url.searchParams.delete('page');
      window.location.replace(url.href);
      return;
    }
    const links = Array.from(topics.querySelectorAll('[data-topic]'));
    links.forEach((link) => {
      link.hidden = link.dataset.topic !== 'all' && !cards.some((card) => card.dataset.articleTopic === link.dataset.topic);
    });
    const render = () => {
      const [requestedTopic, requestedPage] = window.location.hash.slice(1).split('/');
      const topic = links.some((link) => link.dataset.topic === requestedTopic) ? requestedTopic : 'all';
      const matches = cards.filter((card) => topic === 'all' || card.dataset.articleTopic === topic);
      const pages = Math.max(1, Math.ceil(matches.length / 7));
      const page = Math.min(pages, Math.max(1, parseInt(requestedPage, 10) || 1));
      const visible = matches.slice((page - 1) * 7, page * 7);
      cards.forEach((card) => {
        card.hidden = !visible.includes(card);
        card.classList.toggle('yk-journal-card--featured', card === visible[0]);
      });
      links.forEach((link) => {
        if (link.dataset.topic === topic) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
      status.textContent = `${matches.length} ${status.dataset.postsLabel}`;
      pagination.replaceChildren();
      for (let index = 1; index <= pages; index += 1) {
        const link = document.createElement('a');
        link.href = `#${topic}/${index}`;
        link.textContent = String(index);
        link.setAttribute('aria-label', `${pagination.dataset.pageLabel} ${index}`);
        if (index === page) link.setAttribute('aria-current', 'page');
        pagination.append(link);
      }
      pagination.hidden = pages < 2;
      topics.hidden = false;
    };
    window.addEventListener('hashchange', render);
    render();
  });
})();
